export default __webpack_public_path__ + "static/media/excellence.4139bff5.svg";